<div class="globe-layout-container" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
  <!-- Minimal Loading Overlay till Earth is ready -->
  <div class="globe-loading-overlay" [class.hidden]="!isGlobeLoading">
    <div class="spinner-container">
      <div class="app-spinner"></div>
      <span class="loading-globe-text"></span>
    </div>
  </div>


  <!-- Shooting stars background animation -->
  <div class="shooting-stars-wrapper" *ngIf="isDarkMode" aria-hidden="true">
    <div class="shooting-star star-1"></div>
    <div class="shooting-star star-2"></div>
    <div class="shooting-star star-3"></div>
    <div class="shooting-star star-4"></div>
    <div class="shooting-star star-5"></div>
    <div class="shooting-star star-6"></div>
  </div>

  <div class="globe-wrapper">
    <div #globeContainer class="globe-container"></div>
  </div>

  <div class="globe-text-content">

    <!-- ============================================== -->
    <!-- DEFAULT STATE (BEFORE CLICK)                   -->
    <!-- ============================================== -->
    <div class="default-view-content" *ngIf="!selectedLocation">
      <!-- Referral badge (top, small pill) -->
      <div class="referral-badge" *ngIf="agentName">
        <span class="badge-icon">✓</span>
        <span class="badge-text">Referred by {{ agentName }}</span>
      </div>

      <!-- Headline -->
      <h1 class="main-title">Fund Your Next Adventure</h1>

      <!-- Rotating line (typewriter style) -->
      <div class="typewriter-line">
        <span class="typewriter-text">{{ typewriterText }}</span>
        <span class="typewriter-cursor">|</span>
      </div>

      <!-- Money hook (large, gold) -->
      <div class="money-hook-box">
        <div class="money-hook-amount">
          Starting at <span class="gold-gradient-text">₹9,333/month</span> per ₹1 lakh*
        </div>
        <div class="money-hook-subtitle">
          Check your exact rate in 60 seconds.
        </div>
        <div class="money-hook-disclaimer">
          *12-month tenure. Rate varies by profile. Subject to lender approval.
        </div>
      </div>

      <!-- Subtext -->
      <p class="subtext-line">
        Pick a destination. Get pre-approved in 60 seconds. Travel now, pay in easy monthly instalments.
      </p>

      <!-- Trust row (3 small icons) -->
      <div class="trust-row">
        <div class="trust-pill">
          <span class="trust-icon">⚡</span>
          <span class="trust-text">60-second pre-approval</span>
        </div>
        <div class="trust-pill">
          <span class="trust-icon">🛡️</span>
          <span class="trust-text">No impact on credit score</span>
        </div>
        <div class="trust-pill">
          <span class="trust-icon">🤝</span>
          <span class="trust-text">RBI-regulated lending partner</span>
        </div>
      </div>

      <!-- Instruction -->
      <div class="instruction-row">
        <span class="instruction-icon">👆</span>
        <span class="instruction-text">Tap a glowing marker or spin the globe</span>
      </div>

      <!-- Action buttons -->
      <div class="actions-wrapper">
        <button class="surprise-btn" (click)="surpriseMe()" [disabled]="isSpinningSurprise"
          title="Spin the globe and pick a random destination">
          <span class="btn-dice" [class.spinning]="isSpinningSurprise">🎲</span>
          <span class="btn-surprise-content">
            <span class="btn-surprise-title">{{ isSpinningSurprise ? 'Finding your destination...' : 'Surprise Me!'
              }}</span>
          </span>
          <span class="btn-surprise-sparkle">✨</span>
        </button>

        <button class="secondary-btn" (click)="selectGlobal()">
          <span class="btn-icon">✈️</span>
          <span class="btn-text">Not sure where to go? Get pre-approved for any trip</span>
          <span class="btn-arrow">→</span>
        </button>
      </div>

      <!-- Footer micro-line -->
      <div class="footer-micro">
        No hidden charges · Easy AutoPay · Instant support
      </div>
    </div>

    <!-- ============================================== -->
    <!-- AFTER DESTINATION CLICK                        -->
    <!-- ============================================== -->
    <div class="destination-detail-content" *ngIf="selectedLocation">
      <div class="destination-card">
        <!-- Card title -->
        <div class="card-header">
          <span class="card-icon">{{ selectedLocation?.isShip || selectedLocation?.id === 'mumbai' ? '🛳️' : '✈️'
            }}</span>
          <h2 class="card-title">{{ getDestinationCard(selectedLocation.id).name }}</h2>
        </div>

        <!-- Card line -->
        <p class="card-line">{{ getDestinationCard(selectedLocation.id).cardLine }}</p>

        <!-- Card details (3 chips) -->
        <div class="chips-container">
          <div class="chip-item">
            <span class="chip-icon">🗓️</span>
            <span class="chip-label">Best time:</span>
            <span class="chip-value">{{ getDestinationCard(selectedLocation.id).bestTime }}</span>
          </div>

          <div class="chip-item">
            <span class="chip-icon">{{ selectedLocation?.isShip || selectedLocation?.id === 'mumbai' ? '⚓' : '✈️'
              }}</span>
            <span class="chip-value">{{ getDestinationCard(selectedLocation.id).flightTime }}</span>
          </div>

          <div class="chip-item cost-chip">
            <span class="chip-icon">💰</span>
            <span class="chip-label">{{ getDestinationCard(selectedLocation.id).tripDuration }} ≈</span>
            <span class="chip-value">{{ getDestinationCard(selectedLocation.id).estCost }}</span>
            <span class="chip-arrow">→</span>
            <span class="emi-pill">₹{{ getDestinationCard(selectedLocation.id).monthlyEmi }}/month</span>
          </div>
        </div>

        <!-- Primary button -->
        <button class="primary-btn" (click)="proceedToSignup()">
          <span class="btn-text">CHECK MY LIMIT</span>
          <span class="btn-arrow">→</span>
        </button>

        <!-- Under button -->
        <p class="under-button-text">
          Takes 60 seconds. Won't affect credit score.
        </p>

        <!-- Link -->
        <button class="back-link-btn" (click)="deselectLocation()">
          <span class="link-arrow">←</span>
          <span class="link-text">Pick another destination</span>
        </button>
      </div>
    </div>

  </div>
</div>